import { useParams } from "react-router";
import { useEffect, useRef, memo } from "react";
import { useHydrateReaderData } from "./hooks/useHydrateReaderStore";
import { useGaTracking } from "../../hooks/useGaTracking";
import { useViewPortScale } from "../../hooks/useViewPortScale";
import { rootComponentsStore } from "../../hookstate/rootComponentsStore";
import { readerDataStore } from "../../hookstate/readerDataStore";
import { readerComponentsStore } from "../../hookstate/readerComponentStore";
import { useReadingSessionTracking } from "../../analytics/hooks/useReadingSessionTracking";

interface ReaderStateWrapperProps {
  children: JSX.Element | JSX.Element[];
}
export const ReaderStateWrapper = memo(function ReaderStateWrapper({
  children,
}: ReaderStateWrapperProps) {
  const { removeThirdPartyGaId } = useGaTracking();
  const { uuid } = useParams();

  useViewPortScale();
  useHydrateReaderData(uuid ?? "");
  useReadingSessionTracking();

  useEffect(() => {
    readerComponentsStore.showEndInterstitial.set(false);
  }, [uuid]);

  const homeSidebarState = useRef(false);
  useEffect(() => {
    rootComponentsStore.isTopBarHidden.set(false);
    homeSidebarState.current = rootComponentsStore.isSidebarOpen.get();
    return () => {
      readerDataStore.set({});
      readerComponentsStore.showEndInterstitial.set(false);
      readerComponentsStore.vpScale.set(1);
      rootComponentsStore.isSidebarOpen.set(homeSidebarState.current);
    };
  }, []);

  useEffect(() => {
    const readerData = readerDataStore.get({ noproxy: true });

    const releaseData = readerData.releaseData;
    if (releaseData?.artist) {
      removeThirdPartyGaId(releaseData?.comic?.artist.name ?? "");
    }

    if (Object.values(readerData).length > 0) {
      readerDataStore.merge({
        accessData: undefined,
        releaseData: undefined,
        releasePagesData: undefined,
        releaseCommentsData: undefined,
        releaseAnnotationsData: undefined,
        releaseFragmentsData: undefined,
        relatedReleasesData: undefined,
        loaded: false,
      });
    }
  }, [uuid]);

  return children;
});
